import { Typography } from "@mui/material";
import { Checkbox as CheckboxMui, CheckboxWithError, InputWrapper, LabelStyled, classes } from "./styles";

/**
 * @deprecated
 */
export const Checkbox = ({
  id,
  label,
  value,
  onChange,
  style,
  disabled,
  required,
  typography,
  error,
  endLabel,
  color,
  ...props
}) => {
  if (endLabel) {
    return (
      <Typography variant={typography} id={`label-${id}`}>
        <CheckboxMui id={`checkbox-${id}`} size="small" checked={value} color={color} onChange={onChange} {...props} />
        {label}
      </Typography>
    );
  } else {
    return (
      <InputWrapper>
        <LabelStyled
          shrink={false}
          htmlFor={id}
          {...style}
          disabled={disabled}
          required={required}
          error={error}
          className={classes.label}
        >
          {label}
        </LabelStyled>

        <CheckboxWithError
          id={id}
          checked={value}
          onChange={onChange}
          color="default"
          inputProps={{ "aria-label": "checkbox-default-aria-label" }}
          disabled={disabled}
          required={required}
          error={error}
          {...props}
        />
      </InputWrapper>
    );
  }
};
